import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchBox from "@/components/base/SearchBox";
import MyLibraryMenu from "@/components/feature/MyLibraryMenu";

const navLinks = [
  { label: "电影", to: `/category/${encodeURIComponent("电影")}` },
  { label: "电视剧", to: `/category/${encodeURIComponent("电视剧")}` },
  { label: "综艺", to: `/category/${encodeURIComponent("综艺")}` },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 h-[72px] transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200/70 bg-background-50/95 backdrop-blur"
          : "bg-gradient-to-b from-background-50/95 to-transparent"
      }`}
    >
      <div className="mx-auto flex h-full max-w-[1280px] items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-foreground-950">
            <i className="ri-movie-2-line text-xl"></i>
          </span>
          <span className="font-heading text-lg font-semibold tracking-wide text-foreground-950">
            我的家庭教师
          </span>
        </Link>

        <nav className="ml-2 hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-primary-500/15 text-accent-400"
                    : "text-foreground-700 hover:text-foreground-950"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 md:gap-3">
          <SearchBox variant="navbar" />
          <MyLibraryMenu />
          <Link
            to="/search"
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300/60 bg-background-100 text-foreground-800 transition-colors hover:text-foreground-950 lg:hidden"
            aria-label="搜索"
          >
            <i className="ri-search-line text-lg"></i>
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300/60 bg-background-100 text-foreground-800 md:hidden"
            aria-label="菜单"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-b border-background-200/70 bg-background-50 md:hidden">
          <nav className="mx-auto flex max-w-[1280px] flex-col px-4 py-3">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm transition-colors ${
                    isActive
                      ? "bg-primary-500/15 text-accent-400"
                      : "text-foreground-700 hover:bg-background-200/70 hover:text-foreground-950"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}